module.exports = __webpack_public_path__ + "static/img/wisdomApply1.6037b106.png";